import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  template: `
    <mat-dialog-content>
      <h5>{{ data.titulo }}</h5>
      <p>
        {{ data.msg }}?
      </p>
    </mat-dialog-content>

    <div matDialogActions class="w-100 d-flex justify-content-between">
      <button
        [matDialogClose]="false"
        id="denny-btn"
        mat-stroked-button
        color="primary"
        type="button"
      >
        Cancelar
      </button>
      <button
        [matDialogClose]="true"
        id="confirm-btn"
        mat-flat-button
        color="primary"
        type="submit"
      >
        Confirmar
      </button>
    </div>
  `
})
export class DialogConfirmComponent {
  // eslint-disable-next-line no-useless-constructor
  constructor( @Inject(MAT_DIALOG_DATA) public data: { titulo: string; msg: string; }) {}
}
